export const CHART_PALETTE = [
    { color1: '#FF8FAB', color2: '#DDB8FE' }, // purple
    { color1: '#89B9B9', color2: '#67C9A4' }, // green
    { color1: '#181F67', color2: '#477090' }, // blue
]

// Returns the palette entry at index, cycling if more than 3 series are needed
export const getPaletteColor = (index) => CHART_PALETTE[index % CHART_PALETTE.length]
